import { Card, Flex, Heading, IconButton, Image, Separator } from '@chakra-ui/react';
import { memo, useMemo } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';

import UnitSalesOverview from '@features/inventory/UnitSalesOverview';
import { productCatalog, ProductDetails } from 'helpers/fakeData';

const UnitDetails = ({ product }: { product: ProductDetails }) => {
  return (
    <Flex w="full" justifyContent="center">
      <Image height="2xs" fit="contain" src={product.image} alt={product.name} />
    </Flex>
  );
};

const SimplePagination = () => {
  return (
    <Flex flexDir="row" gap={2}>
      <IconButton
        _hover={{
          bgColor: 'sidebar.hoverButton',
          color: 'icon.primary',
        }}
        variant="ghost"
      >
        <HiChevronLeft />
      </IconButton>
      <IconButton
        _hover={{
          bgColor: 'sidebar.hoverButton',
          color: 'icon.primary',
        }}
        variant="ghost"
      >
        <HiChevronRight />
      </IconButton>
    </Flex>
  );
};

const UnitOverview = () => {
  const selectedUnitIndex = 2;

  const selectedUnit = useMemo(() => {
    return productCatalog[selectedUnitIndex];
  }, [selectedUnitIndex]);

  return (
    <Card.Root w="full" minH="2xl" bg="surface.background" borderColor="border.light">
      <Card.Header>
        <Heading size="md">{`${selectedUnit.name} (${selectedUnit.model})`}</Heading>
      </Card.Header>
      <Separator mt={2} orientation="horizontal" borderColor="border.light" />
      <Card.Body>
        <Flex w="full" flexDir="column" alignItems="center" gap={4}>
          <UnitDetails product={selectedUnit} />
          <SimplePagination />
          <UnitSalesOverview type="weekly" />
          <UnitSalesOverview type="total" />
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};

export default memo(UnitOverview);
